export const environment = {
  production: true,
  buildId: '3922956052823841',
  configFile: 'config.json',
};
